import { forwardRef } from 'react';
import { Tooltip, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger } from '@mweb/zappos-ui/Tooltip';

import type { ProductBadgeProps } from 'components/common/ProductBadge/ProductBadge.types';
import {
  containerClasses,
  diagonalClasses,
  labelClasses,
  tooltipClasses,
  wrapperClasses
} from 'components/common/ProductBadge/ProductBadge.classes';
import { cn } from 'helpers/classnames';

export const ProductBadge = forwardRef<HTMLDivElement, ProductBadgeProps>((props: ProductBadgeProps, ref) => {
  const { children, helpText, fontColor = 'text-primary', className, size, ...forwardProps } = props;

  const badgeLabel = (
    <span className={labelClasses({ size })} style={{ color: fontColor }}>
      {children}
    </span>
  );

  return (
    <div ref={ref} className={cn(wrapperClasses({ size }), className)} {...forwardProps}>
      <div className={containerClasses({ size })}>
        {!helpText ? (
          badgeLabel
        ) : (
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger asChild>{badgeLabel}</TooltipTrigger>
              <TooltipPortal>
                <TooltipContent side="bottom" sideOffset={4} align="start" alignOffset={16} className={tooltipClasses}>
                  {helpText}
                </TooltipContent>
              </TooltipPortal>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      <div className={diagonalClasses({ size })} data-test-id="badgeBackground" />
    </div>
  );
});
